import React, { ComponentPropsWithoutRef } from 'react';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { Typography } from 'components/ui/typography';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';

import { Total, TotalLabel, TotalsRow } from './styled';

type TextProps = ComponentPropsWithoutRef<typeof Typography>;

export const TaxesRow: React.FC<React.PropsWithChildren<{
  taxCents: number;
  isLoading?: boolean;
  textProps?: TextProps;
}>> = ({ taxCents, isLoading, textProps }) => {
  return (
    <TotalsRow>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <A11yWrapper>
            <TotalLabel {...(textProps && { fontSize: 'md' })}>{t('tax')}</TotalLabel>
          </A11yWrapper>
          <Total>
            <Currency textProps={textProps} amount={taxCents} testID="totalTax" />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};
